import { render, staticRenderFns } from "./PneuMedidas.vue?vue&type=template&id=671ff8f5&"
import script from "./PneuMedidas.vue?vue&type=script&lang=js&"
export * from "./PneuMedidas.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PneuMedidas.vue?vue&type=style&index=1&id=671ff8f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports